import { Component, OnInit, Input, Output, EventEmitter, ViewChild, NgZone } from '@angular/core';
import { MatDialog } from '@angular/material';

import { DistributionList } from './distribution-list.model';
import { DistributionListsService } from '../users/distribution-lists.service';
import { UsersService } from '../users/users.service';
import { SuccessDialogComponent } from '../shared/success-dialog.component';
import { ErrorDialogComponent } from '../shared/error-dialog.component';
import { AutocompleteTokensFieldComponent } from '../forms/autocomplete-tokens-field.component';
import { FieldComponent } from '../forms/field.component';

@Component({
  selector: 'app-distribution-lists-form',
  templateUrl: './distribution-lists-form.component.html',
  styleUrls: ['./distribution-lists-form.component.scss']
})
export class DistributionListsFormComponent implements OnInit {
  @Input() list: DistributionList;
  @Output() canceled = new EventEmitter<null>();
  @Output() finished = new EventEmitter<null>();
  @ViewChild("nameField") nameField: FieldComponent;
  @ViewChild("submitButton") submitButton;
  @ViewChild("usersField") usersField: FieldComponent;
  @ViewChild("workflowsField") workflowsField: AutocompleteTokensFieldComponent;

  availableWorkflows: any[] = [];
  loading: boolean = true;
  submitting: boolean = false;
  valid: boolean = false;

  get listUsers() {
    return this.list.users.map((u) => {
      return {stored: u, displayed: (u.name != null ? u.name : u.email)}
    })
  }
  
  get listWorkflows() {
    let workflows: any[] = [];
    for (let id of this.list.workflowIds) {
      let workflow = this.availableWorkflows.find((w) => w.stored === ''+id);
      if (workflow != null) { workflows.push(workflow) }
    }
    return workflows;
  }

  constructor(
    private ngZone: NgZone,
    public dialog: MatDialog,
    private distributionListsService: DistributionListsService,
    private usersService: UsersService) { }

  ngOnInit() {
    if (this.list == null) {
      this.list = new DistributionList();
    }

    this.usersService.profile.subscribe(
      (profile) => {
        this.availableWorkflows = profile.workflows.map((w) => {
          return { stored: ''+w.id, displayed: w.name }
        })
        this.loading = false;
      },
      (error) => this.loading = false
    )

    this.validate();
  }

  onValueChange(event) {
    switch (event.field) {
    case 'name':
      this.list.name = event.value;
      break;
    case 'public':
      this.list.isPublic = event.value;
      break;
    case 'users':
      this.list.users = event.value.map((v) => v.stored);
      break;
    case 'workflows':
      this.list.workflowIds = event.value.map((v) => +v.stored);
      break;
    }
    this.validate();
  }

  validate() {
    let valid = this.nameField.valid && this.usersField.valid

    if (this.list.isPublic) {
      if (this.list.workflowIds.length == 0) {
        valid = false;
      }
    }

    this.valid = valid;
  }

  onSubmit() {
    if (this.submitting) {return};
    this.submitting = true;
    if (this.list.id == null) {
      this.distributionListsService.createList(this.list).subscribe(
        (result) => {
          this.ngZone.run(() => {this.showSuccessDialog("List Successfully Created")});
          this.submitting = false;
          this.finished.emit();
        },
        (error) => {
          this.submitting = false;
          let message: string;
          if (error.message == "name_conflict") {
            message = "A list with the same name already exists"
          } else {
            message = "Failed to Create List"
          }
          this.ngZone.run(() => {this.showErrorDialog(message)})
        }
      )
    } else {
      this.distributionListsService.updateList(this.list).subscribe(
        (result) => {
          this.ngZone.run(() => {this.showSuccessDialog("List Successfully Updated")});
          this.submitting = false;
          this.finished.emit();
        },
        (error) => {
          this.submitting = false;
          let message: string;
          if (error.message == "name_conflict") {
            message = "A list with the same name already exists"
          } else {
            message = "Failed to Update List"
          }
          this.ngZone.run(() => {this.showErrorDialog(message)})
        }
      )
    }
  }

  showSuccessDialog(message) {
    let dialogRef = this.dialog.open(SuccessDialogComponent, {
      height: '240px',
      width: '320px',
      data: {message: message}
    });
    setTimeout(() => dialogRef.close(), 3000);
  }

  showErrorDialog(message) {
    let dialogRef = this.dialog.open(ErrorDialogComponent, {
      height: '240px',
      width: '320px',
      data: {message: message}
    });
    setTimeout(() => dialogRef.close(), 6000);
  }

}


// WEBPACK FOOTER //
// ./src/app/users/distribution-lists-form.component.ts